import styled from 'styled-components'
import wrongImageUrl from '../assets/wrong-url-image.png'
import { SiteStatus } from '../types/assets'
import { Footer } from './Footer'

export const StyledPageNotFound = styled.div`
  max-width: ${props => props.theme.maxWidth};
  margin: auto;
  text-align: center;
  padding-top: 3rem;
  padding-left: 4vw;
  padding-right: 4vw;

  .alert {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #565656;
    color: #fbda57;
    padding: 1.3rem;
    border-radius: 50px;
    font-size: 12pt;
    text-align: left;

    i {
      font-size: 22pt;
      margin-right: 8px;
    }
  }

  .wrong-page-img {
    max-width: calc(50% - 10vw);
    margin: 2rem auto;
  }

  .learn-button {
    width: fit-content;
    background-color: #f05836;
    padding: 0.6rem 1rem;
    margin: 2rem auto;

    a {
      text-decoration: none;
      color: #fff;
    }
  }

  .learn-button:hover {
    cursor: pointer;
    background-color: #d96f58;
  }
`

type PageNotFoundProps = {
  status?: SiteStatus
}

const PageNotFound = ({ status }: PageNotFoundProps) => {
  let label =
    status === 'Inactive'
      ? 'This site is Inactive'
      : 'This site does not exist or is still being deployed. Please check the url, reload or contact the education provider.'

  return (
    <StyledPageNotFound>
      <div
        className="alert"
        role="alert"
      >
        <i className="fas fa-exclamation-circle"></i>
        {label}
      </div>
      {status !== 'Inactive' && (
        <>
          <img
            className="wrong-page-img"
            src={wrongImageUrl}
            alt="Page Not Found Please go back"
          />
          <h3>Sales+ allows you to streamline Online Enquiries and Applications</h3>
          <br />
          <Footer />
        </>
      )}
    </StyledPageNotFound>
  )
}

export default PageNotFound
